export default "__VITE_ASSET__CE4Yn$33__"